import { persist } from 'zustand/middleware'
import { create } from 'zustand/react'

import { WorkspaceTableMode, WorkspaceWorkMode } from '../../../modules/workspace/workspace/constants/workspace.constants'
import { WorkspaceConfiguration } from '../../../modules/workspace/workspace/types/wrokspace.types'
import { ObjectItem } from '../../objects/types/object.types'
import { MilestoneItem } from '../types/workflow.types'

type WorkspaceStore = {
  checkedMilestones: Set<number>
  checkedObjects: Set<number>
  selectedMilestone: MilestoneItem | null
  workspaceConfiguration: WorkspaceConfiguration
  isExpanded: boolean
  setSelectedMilestones: (checkedMilestones: Set<number>) => void
  setCheckedObjects: (checkedObjects: Set<number>) => void
  setSelectedMilestone: (milestone: MilestoneItem | null) => void
  setSelectedObject: (object: ObjectItem | null) => void
  setConfiguration: (config: Partial<WorkspaceConfiguration>) => void
  selectedObject: ObjectItem | null
  setExpanded: (isExpanded: boolean) => void
}

export const useWorkspaceStore = create<WorkspaceStore>()(
  persist(
    (set, get): WorkspaceStore => ({
      checkedMilestones: new Set<number>(),

      workspaceConfiguration: { tableMode: WorkspaceTableMode.Dates, workMode: WorkspaceWorkMode.Filling },

      selectedMilestone: null,

      selectedObject: null,

      isExpanded: false,

      checkedObjects: new Set<number>(),

      setSelectedMilestones: (checkedMilestones: Set<number>) => {
        set({ checkedMilestones })
      },

      setCheckedObjects: (checkedObjects: Set<number>) => {
        set({ checkedObjects })
      },

      setSelectedMilestone: (milestone: MilestoneItem | null) => {
        set({ selectedMilestone: milestone })
      },

      setSelectedObject: (object: ObjectItem | null) => {
        set({ selectedObject: object })
      },

      setConfiguration: (config: Partial<WorkspaceConfiguration>) => {
        const workspaceConfiguration = get().workspaceConfiguration
        set({ workspaceConfiguration: { ...workspaceConfiguration, ...config } })
      },

      setExpanded: (isExpanded: boolean) => {
        set({ isExpanded: isExpanded })
      },
    }),
    {
      name: 'workspace',
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name)
          if (!str) return null
          const { state, version } = JSON.parse(str)

          return {
            state: {
              ...state,
              checkedMilestones: new Set(state.checkedMilestones),
              checkedObjects: new Set(state.checkedObjects),
            },
            version,
          }
        },
        setItem: (name, newValue) => {
          const serializedState = JSON.stringify({
            state: {
              ...newValue.state,
              checkedMilestones: Array.from(newValue.state.checkedMilestones),
              checkedObjects: Array.from(newValue.state.checkedObjects),
            },
            version: newValue.version,
          })
          localStorage.setItem(name, serializedState)
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
)
